import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { AppConfig } from '../../app/app.config';
declare const xinbaoSanMaintenanceInfo: any; // 声明外部函数
@IonicPage()
@Component({
  selector: 'page-newmaintain',
  templateUrl: 'maintain.html',
})
export class NewMaintainPage {
  maintenance = {
    period: '',
    serviceUrl: '',
  };
  constructor(
    private config: AppConfig,
  ) {}


  ionViewDidLoad() {
    this.loadExternalScript();
  }

  public loadExternalScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    let date = new Date().getTime();
    script.src = `https://newupimg.haozigo.com/common/common.js?_t=${date}`; // 替换为外部JS文件的URL
    script.onload = () => {
      this.executeFunction();
    };
    document.body.appendChild(script);
  }

  executeFunction() {
    if (typeof xinbaoSanMaintenanceInfo === 'function') {
      this.maintenance = xinbaoSanMaintenanceInfo();
    } else {
      console.error('xinbaoSanMaintenanceInfo function not found');
    }
  }

  kefuService() {
    this.config.openUrl(this.maintenance.serviceUrl);
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-maintain/maintain.ts